<template lang="pug">
v-content.pa-0
  v-row(wrap)
    v-col(xs="12", sm="6", md="4", lg="3", xl="2")
      v-sheet
        small
          template(v-if="!billText")
            pre.
              \n{{generate()}}              
          template(v-else)
            pre.
              \n{{billText}}              
</template>
<script>
import moment from "moment";
import { storeMixin } from "../../mixins/storeMixin.js";
import { taxPlans } from "../../config/taxPlans.js";

export default {
  name: "ezbill",
  mixins: [storeMixin],
  mounted() {
    this.$emit("billShown");
  },
  data: () => ({
    collectionName: "orders",
    amountReceivable: "",
    divider: "--------------------------------", //--------------"
  }),
  props: { billText: String },
  computed: {
    bills() {
      const bills = [];
      const bins = this.serviceOrders.map((s) => String(s.billNum));
      const billNums = [...new Set(bins)]; //de-dupe the array
      billNums.forEach((n) => {
        bills.push({
          billNum: n,
          trackOrders: this.serviceOrders.filter(
            (o) => o.billNum == n && o.status >= this.STATUSES.INTRANSIT
          ),
          pendingOrders: this.serviceOrders.filter(
            (o) => o.billNum == n && o.status < this.STATUSES.INTRANSIT
          ),
        });
      });
      return bills;
    },
  },
  methods: {
    generate() {
      const billLines = [];
      this.bills.forEach((bill) => {
        billLines.push(this.divider);
        billLines.push(this.getHeader(bill.billNum));
        billLines.push(this.divider);
        billLines.push("          TAX Invoice          ");
        billLines.push(this.divider);
        billLines.push(
          `Customer:${this.selectedService.customerName
            .substring(0, 21)
            .padEnd(21, " ")}`
        );
        billLines.push(`Mobile:${this.selectedService.mobile}`);
        billLines.push(this.divider);
        bill.trackOrders.forEach((order) => {
          billLines.push(
            `${order.productName.padEnd(23, " ")} ${parseFloat(order.price)
              .toFixed(2)
              .padStart(8)}`
          );
          billLines.push(
            `(${order.seat}) ${order.quantity}X${
              "@" + parseFloat(order.rate).toFixed(2)
            } (${order.taxPlan})`
          );
        });
        billLines.push(this.divider);
        billLines.push(this.getFooter(bill.trackOrders));
        billLines.push("==< ezServ-R by penzigo.com  >==");
        if (bill.pendingOrders.length) {
          billLines.push(this.divider.replace(/-/g, "x"));
          billLines.push(this.divider);
          billLines.push(" PENDING ORDERS ");
          billLines.push(this.divider);
          bill.pendingOrders.forEach((order) => {
            billLines.push(
              `${order.productName.padEnd(24, " ")} ${parseFloat(order.price)
                .toFixed(2)
                .padStart(8)}`
            );
            billLines.push(
              `(${order.seat}) ${order.quantity}X${
                "@" + parseFloat(order.rate).toFixed(2)
              } (${order.taxPlan})`
            );
          });
          billLines.push(this.divider);
          billLines.push(
            `Pending Total: ${process.env.VUE_APP_CURRENCY} ` +
              this.calcTotalAmount(bill.pendingOrders)
          );
          billLines.push(this.divider);
        }
      });
      return billLines.join("\n");
    },
    getHeader(billNum) {
      const maxCol = 32;
      const lines = [];
      const r = this.selectedRestaurant;
      lines.push(
        `${r.name} (${r.code})`.padStart(
          (maxCol + r.name.length + r.code.length + 3) / 2,
          " "
        )
      );
      lines.push(
        r.addressLine1.padStart((maxCol + r.addressLine1.length) / 2, " ")
      );
      let line3 = `${r.addressLine2}`;
      line3 = line3.padStart((maxCol + line3.length) / 2, " ");
      lines.push(line3);
      let line4 = `${r.city}, ${r.state}, ${r.pin}`;
      line4 = line4.padStart((maxCol + line4.length) / 2, " ");
      lines.push(line4);
      lines.push("Mobile: " + r.mobile1);
      lines.push("GSTN: " + (r.gstn || "GSTN Applied"));
      lines.push("Date: " + moment().format("DD/MM/YYYY hh:mmA"));
      lines.push(
        "Bill#: " +
          this.selectedService.createdTS +
          `${billNum == 1 ? "" : "-" + billNum}`
      );
      return lines.join("\n");
    },
    getFooter(orders) {
      const maxCol = 32;
      const lines = [];
      let totalAmount = 0;
      let totalTax = 0;
      lines.push("Tax Details:");
      const taxPlanAggregate = JSON.parse(JSON.stringify(taxPlans));
      orders.forEach((o) => {
        const taxPlan = taxPlanAggregate.find((t) => t.code === o.taxPlan);
        taxPlan.amount = Number(taxPlan.amount || 0) + Number(o.price);
      });
      taxPlanAggregate.forEach((p) => {
        if (p.amount) {
          lines.push(p.code);
          p.components.forEach((c) => {
            c.tax = (Number(p.amount || 0) * Number(c.rate)) / 100;
            lines.push(
              `${c.name} (${c.code}) @ ${c.rate}% ${parseFloat(c.tax).toFixed(
                2
              )}`.padStart(maxCol, " ")
            );
            totalTax += c.tax;
          });
          totalAmount += p.amount;
        }
      });
      lines.push(this.divider);
      lines.push(
        `Total Tax Amount: ${process.env.VUE_APP_CURRENCY} ${parseFloat(
          totalTax
        ).toFixed(2)}`.padStart(maxCol, " ")
      );
      lines.push(
        `Total Amount: ${process.env.VUE_APP_CURRENCY} ${parseFloat(
          totalAmount
        ).toFixed(2)}`.padStart(maxCol, " ")
      );
      lines.push(this.divider);
      return lines.join("\n");
    },
    calcTotalAmount(orders) {
      orders = orders || this.serviceOrders;
      let total = 0.0;
      total = orders.reduce((acc, v) => {
        return acc + Number(v.price);
      }, total);
      return parseFloat(total).toFixed(2);
    },
  },
};
</script>
